import { datadogLogs } from '@datadog/browser-logs'

import { apiFetch, logoutOnRequestOrResponseJson } from './api'

/*
 * The chatId in the body is only a request to resume: the server honours it only when the session this call
 * carries was issued for that chat, and otherwise starts a new one. Either way the answer is the chat to use,
 * and the response carries the credential for it.
 */
export const getChatIdRequest = data => {
  return apiFetch('/sockwidget/getStarted', {
    method: 'POST',
    body: JSON.stringify(data)
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => response.data)
    .catch(error => datadogLogs.logger.error(error))
}

export const getChatHistoryRequest = (botId, size, page = 0) => {
  return apiFetch(`/widget/${botId}/chat?size=${size}&page=${page}&sort=id,desc`, {
    method: 'GET'
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => {
      return response?.data?.content
    })
    .catch(error => datadogLogs.logger.error(error))
}
